import { render, staticRenderFns } from "./tradesmanAdd.vue?vue&type=template&id=dd50d48c&scoped=true&"
import script from "./tradesmanAdd.vue?vue&type=script&lang=js&"
export * from "./tradesmanAdd.vue?vue&type=script&lang=js&"
import style0 from "./tradesmanAdd.vue?vue&type=style&index=0&id=dd50d48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd50d48c",
  null
  
)

export default component.exports